import script from "./CourseAccordian.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAccordian.vue?vue&type=script&setup=true&lang=js"

import "./CourseAccordian.vue?vue&type=style&index=0&id=69bf6ff7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bf6ff7"]])

export default __exports__